import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedDoc: null,
};

export const SOPViewerSlice = createSlice({
  name: "SOPViewer",
  initialState,
  reducers: {
    updsateSelectedDoc: (state, action) => {
      return {
        ...state,
        selectedDoc: action.payload,
      };
    },
  },
});

export const { updsateSelectedDoc } = SOPViewerSlice.actions;

export default SOPViewerSlice.reducer;
